import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-table-loading-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table-loading-bar.component.html',
  styleUrls: ['./table-loading-bar.component.scss']
})
export class AvTableLoadingBarComponent {
  @Input() isLoading: boolean = false;
}
